module.exports = __webpack_public_path__ + "static/burst-kUqqaRjJuw0-unsplash-db50f4b11ff396b3d18704e5ec35aa24.jpg";